import alertState from 'optinmonster-js-library/src/vue/campaigns/store/alerts/state';
import { getApiKey } from 'optinmonster-js-library/src/utils';
import { disableDevCookie } from 'optinmonster-js-library/src/utils/apiKey';
import { getAppData } from 'optinmonster-js-library/src/vue/utils';
import queryArgs from 'optinmonster-js-library/src/utils/queryArgs';
import { setQueryArgs } from '@/utils/debug';

disableDevCookie();

const fullName = [getAppData('userFirstName', ''), getAppData('userLastName', '')]
	.filter((n) => Boolean(n && String(n).trim()))
	.join(' ');

export const userDefaultState = () => ({
	id: 0,
	email: getAppData('userEmail', ''),
	name: fullName || '',
	firstName: getAppData('userFirstName', ''),
	lastName: getAppData('userLastName', ''),
	phone: '',
	company: '',
	industry: '',
	company_size: '',
	address: {
		address1: '',
		address2: '',
		city: '',
		state: '',
		zip: '',
		country: '',
	},
	created: 0,
	updated: 0,
	plan: '',
	lastLogin: 0,
	role: '',
	status: '',
	default_site: 0,
	permissions: [],
	beta: {
		enabled: false,
	},
	completion: 0,
	accountId: 0,
	accountUserId: 0,
	accountEmail: '',
	accountName: '',
	accountActive: false,
	accountEnabled: false,
	integrations: [],
	features: [],
	ruleTypes: [],
	campaignTypes: [],
	legacyUser: false,
	hasShopify: false,
	hasWooCommerce: false,
	hasBigCommerce: false,
	hasEdd: false,
	inBeta: false,
	level: '',
	planName: 'OptinMonster',
	currentLevel: '',
	planVersion: '',
	userStatus: '',
	topTier: false,
	hasLiveChat: false,
	hasLeadVerification: true,
	hasCustomDomains: true,
	limits: {
		sites: 1,
		folders: 200,
		campaigns: 3,
		impressions: 500,
		users: 0,
		leads: 10000000000000000,
		integrationslimit: 1,
		impressionsBlock: 100000,
	},
	revenueAttribution: {
		enabled: true,
		currency: 'USD',
	},
	hasCompletedPostCampaignSurvey: false,
	isAmTeam: false,
	isOmAlpha: true,
	hasPrioritySupport: false,
	onboarding: {
		via: '',
		usage: '',
		usage_other_text: '',
		email_list: null,
		email_service: '',
		email_service_other_text: '',
		goal: [],
	},
});

export default {
	...alertState,
	bannerTitle: '',
	loading: [],
	fetched: [],
	fetching: [],
	user: userDefaultState(),
	apiKey: getApiKey(),
	apiKeyValid: !!getApiKey(),
	queryArgs: setQueryArgs(queryArgs.parse()),
	showReview: getAppData('showReview', false),
	visits: {},
};
